import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import {Item} from '../../models/Item';
import {ThreeWordsService} from '../../services/3Words/three-words.service';
import {MeasurementService} from '../../services/measurementAdapter/measurement.service';
import {ItemSettingsComponent} from '../../components/item-settings/item-settings.component';
import {CalculateInputsService} from '../../services/calculateInputsService/calculate-inputs.service';
import {TimelineService} from '../../services/timeline/timeline.service';
import {ItemParticipantComponent21} from '../item-participant/item-participant.component';
import {staticFields} from '../../../configs/staticFieldsMap';
import {
  STATIC_FIELD_IN_DATE,
  STATIC_FIELD_OUT_DATE,
  IMG_TYPE_IMAGE,
  IMG_TYPE_PANOLENS,
  INPUT_TYPE_COLOR, INPUT_TYPE_COLORSELECT, INPUT_COLOR_SETTINGS_NAME, INPUT_OPACITY_SETTINGS_NAME, INPUT_TYPE_FILE
} from '../../interfaces/constants';
import {GlobalEventsService} from 'src/app/services/global-events.service';
import {ObjectConfig} from "../../models/ObjectConfig";
import {Subscription, timer, Subject} from "rxjs";
import {ItemLocationComponent} from "../item-location1/item-location.component";
import { takeUntil, debounceTime } from 'rxjs/operators';
import {CesiumAdapterService} from '@src/app/services/cesiumAdapter21/cesium-adapter.service';
import {isPresetEnabled} from '@src/configs/globalVariables';
import {appInjector} from "@src/app/classes/appInjector";
import {HttpServiceService} from "@src/app/services/httpService/http-service.service";
import {HttpHeaders, HttpParams} from "@angular/common/http";
import {ObjectArrayPlugin} from '@src/app/classes/plugins/objectArrayPlugin/object-array-plugin';
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';

declare var UE_LEVELS: { };
declare var UE_FLOORS: {};

@Component({
  selector: 'item-settings',
  templateUrl: './item-settings.component.html',
  styleUrls: ['./item-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemSettingsComponent21 extends ItemSettingsComponent implements AfterViewInit, AfterViewChecked, OnDestroy {

  constructor(
    protected _3Words: ThreeWordsService,
    protected measurement: MeasurementService,
    protected cd: ChangeDetectorRef,
    protected calcInputs: CalculateInputsService,
    protected timelineService: TimelineService,
    protected globalEvents: GlobalEventsService,
    protected cesiumAdapter: CesiumAdapterService,
    protected im: ItemManagerService,
    protected http: HttpServiceService
  ) {
    super(
      _3Words,
      measurement,
      cd,
      calcInputs,
      globalEvents,
      im,
      http
    );
  }

  private itemSettingsListCnt$: Subject<number> = new Subject<number>();
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  public isParticipantVisible = false;
  public isFixedVisible = false;
  private onChanges$:Subscription;
  public isCanChangeColor = false;

  get isSvgLine() {
    if (this.item.config.getTool().type === ObjectConfig.TYPE_POLYLINE) {
      const mo = this.item.getMapObject();
      return mo && mo.isSvgLine();
    }
    return false;
  }

  @ViewChild('participant', {static: false}) participantCo: ItemParticipantComponent21;
  @ViewChild('locationRef', {static: false}) locationCo: ItemLocationComponent;
  @ViewChild('itemSettingsList', {static: false}) itemSettingsList: ElementRef;

  private staticFieldPropMapping = {
    [STATIC_FIELD_IN_DATE]: {time: 'date'},
    [STATIC_FIELD_OUT_DATE]: {time: 'date'},
  };

  ngOnInit(): void {
    super.ngOnInit();
    this.updateChangeColorForPolygons();

    this.itemSettingsListCnt$.pipe(takeUntil(this.destroyed$)).subscribe((cnt) => {
      this.checkEmptyList();
    });

    this.cd.detectChanges();
  }

  ngOnChanges(changes): void {
    super.ngOnChanges(changes);
    this.updateChangeColorForPolygons();
    this.colorSettings = (this.item.config.getInputByName(INPUT_COLOR_SETTINGS_NAME))
      ? (this.item.config.getInputByName(INPUT_COLOR_SETTINGS_NAME))
      : {value: null};

    if (this.colorSettings.value === null) {
      this.colorSettings.value = this.item.config.getTool().default_color;
    }

    this.opacitySettings = (this.item.config.getInputByName(INPUT_OPACITY_SETTINGS_NAME))
      ? (this.item.config.getInputByName(INPUT_OPACITY_SETTINGS_NAME))
      : {value: null};

    if (this.opacitySettings.value === null) {
      this.opacitySettings.value = this.item.config.getTool().default_opacity;
    }

    console.log('opacitySettings', this.opacitySettings);
    this.cd.detectChanges();

    if (this.onChanges$){
      this.onChanges$.unsubscribe();
    }
    this.onChanges$ = new Subscription();
    this.onChanges$.add(this.item.getObservable('RELOAD_COMPONENT').pipe(debounceTime(500)).subscribe(()=>{
      this.locationCo.reloadComponent();
      if (!this.cd['destroyed']){
        this.cd.detectChanges();
      }
    }));

  }

  ngAfterViewInit() {
    this.isParticipantVisible = this.participantCo.isParticipantAvailable();
    this.cd.detectChanges();
  }

  isCopy(){
    return this.item.config.isCopy;
  }

  isFixedFigure(){
    return this.item.config.getTool().type == ObjectConfig.TYPE_FIXED_FIGURE && !this.item.config.getTool().dynamic_image_code
  }

  isObjectsArrayEmpty(){
    return !this.item.config.getInputProp('__objectArray', 'value')
  }

  addObjectArray(){
    this.item.config.setInputValue('__objectArray', 'value', true);
      timer(400).subscribe(()=>{
        this.item.getObservable('RELOAD_COMPONENT').next(true);
        this.cd.detectChanges();
    });
  }

  ngAfterViewChecked() {
    this.itemSettingsListCnt$.next(this.itemSettingsList.nativeElement.children.length);
  }

  private updateChangeColorForPolygons(){
    this.isCanChangeColor = window['CAN_CHANGE_COLOR_OPACITY']
      && (this.item.config.getTool().type == ObjectConfig.TYPE_POLYLINE || this.item.config.getTool().type == ObjectConfig.TYPE_POLYGON);
  }

  public fixedVisibilityChanged(val: boolean) {
    this.isFixedVisible = val;
    this.cd.detectChanges();
  }

  isStaticInputAddAvailable(name) {
    return !this.item.config.getInputs().hasOwnProperty(name);
  }

  toggleVendorProperty($event) {
    if (this.isStaticInputAddAvailable('__vm_vendor_zone')) {
      this.addStaticField('addVendors');
    } else {
      this.deletePropertyProcess('vendor', $event, {name: 'removeVendorsInput', field: 'value'});
    }
    this.cd.detectChanges();
  }

  addStaticField(method) {
    this.item.getSubject(Item.SUBJECT_INPUTS_CHANGED).next(method);
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.cd.detach();
  }

  private checkEmptyList() {
    if (this.itemSettingsList.nativeElement.children.length === 0
      || Array.from(this.itemSettingsList.nativeElement.children).every((el: HTMLElement) => el.hasAttribute('hidden'))) {
      this.itemSettingsList.nativeElement.setAttribute('hidden', 'hidden');
    } else {
      this.itemSettingsList.nativeElement.removeAttribute('hidden');
    }
  }

  private deletePropertyProcess(key, $event, config?: { name: string, field: string }) {
    $event.stopPropagation();
    const methodNameInput = key.replace('__', '');
    const methodName = methodNameInput.charAt(0).toUpperCase() + methodNameInput.slice(1);
    const method = (config && config.name) ? config.name : `remove${methodName}Input`;

    if ($event.target.tagName === 'svg' || $event.target.parentNode.tagName === 'svg') {
      this[method](this.item);
    } else {
      this.deleteEmptyGroupStaticFields(methodNameInput, this[method], (config && config.field) ? config.field : 'value');
    }
  }

  deleteEmptyGroupStaticFields(staticFieldName, removeMethod, inputField?: string) {
    if (staticFields.has(staticFieldName)) {
      const currentInputsArray = staticFields.get(staticFieldName);

      for (const inputKey of currentInputsArray) {
        let currentField = inputField || 'value';

        const mappedField = this.itemInputFieldMap(inputKey, currentField);
        if (mappedField) {
          currentField = mappedField;
        }

        if (
          this.item.config.getInputProp(inputKey, currentField)
          && this.item.config.getInputProp(inputKey, currentField).toString().trim().length > 0
          && this.item.config.getInputProp(inputKey, currentField).toString().trim() !== 'no'
        ) { return; }
      }
      removeMethod(this.item);
    }
  }

  toggleProperty(key, $event): void {
    let methodNameInput = key.replace('__', '');
    methodNameInput = methodNameInput.charAt(0).toUpperCase() + methodNameInput.slice(1);
    if (this.isStaticInputAddAvailable(key)) {
      this.addStaticField(`add${methodNameInput}`);
    } else {
      // todo: addMethodforDelete with staticFieldsMap
      this.deletePropertyProcess(key, $event);
    }
    this.cd.detectChanges();
  }

  toggleTimeProperty($event) {
    if (this.isStaticInputAddAvailable(STATIC_FIELD_IN_DATE)) {
      this.addStaticField('addInOutDates');
    } else {
      this.deletePropertyProcess('time', $event, {name: 'removeInOutDatesInput', field: 'time'});
    }
    this.cd.detectChanges();
  }

  toggleUeLevelAndFloorProperty($event) {
    if (this.isStaticInputAddAvailable('__ue_level')) {
      this.addStaticField('addUeLevelAndFloor');
    } else {
      this.deletePropertyProcess('ue', $event, {name: 'removeUeInput', field: 'value'});
    }
    this.cd.detectChanges();
  }

  getLevels() {
    return UE_LEVELS;
  }

  getFloors() {
    return UE_FLOORS;
  }

  isTimelineEnabled(): boolean {
    return this.timelineService.isEnabled();
  }

  private itemInputFieldMap(key, currentField): string | null {
    if (this.staticFieldPropMapping[key] && this.staticFieldPropMapping[key][currentField]) {
      return this.staticFieldPropMapping[key][currentField];
    }
    return null;
  }

  identity(index, item){
    return item.key;
  }

  isImageSettings(setting: { [key: string]: any }): boolean {
    return  setting.value.hasOwnProperty('type')
      && (setting.value.type === IMG_TYPE_IMAGE || setting.value.type === IMG_TYPE_PANOLENS);
  }

  isFileSettings(setting: { [key: string]: any }): boolean {
    return  setting.value.hasOwnProperty('type')
      && (setting.value.type === INPUT_TYPE_FILE);
  }

  isShowOriginalValue(setting: any): boolean {
    return this.item.config.getInputs()[setting.key].hasOwnProperty('label')
      && this.item.config.getInputs()[setting.key].hasOwnProperty('originalValue')
      && this.item.config.getInputs()[setting.key].hasOwnProperty('show_hint');
  }

  public isSettingsContainColor(){
    let settings = this.getItemSettings();
    for (let i in settings){
      let setting = settings[i];
      if (setting.type){
        if (setting.type == INPUT_TYPE_COLOR || setting.type == INPUT_TYPE_COLORSELECT){
          return true;
        }
      }
    }
    return false;
  }

  isColor(setting: any): boolean {
    return setting.value.type && setting.value.type === INPUT_TYPE_COLOR;
  }

  // isCanChangeColor(): boolean {
  //   return window['CAN_CHANGE_COLOR_OPACITY'] && (this.item.config.getTool().type == ObjectConfig.TYPE_POLYLINE || this.item.config.getTool().type == ObjectConfig.TYPE_POLYGON);
  // }

  isColorSelect(setting: any): boolean {
    return setting.value.type && setting.value.type === INPUT_TYPE_COLORSELECT;
  }

  changeColor(item: Item, setting: any, event: string): void {
    this.cesiumAdapter.isChangingColor = true;
    this.validateItemParam(item, setting.key || INPUT_COLOR_SETTINGS_NAME, 'value', event);
    this.logPropChanges('color.change', {
      itemId: item.getId(),
      prop: setting.key || INPUT_COLOR_SETTINGS_NAME
    });
  }

  changeOpacity(item: Item, setting: any, value: number){
    this.validateItemParam(item, setting.key || INPUT_OPACITY_SETTINGS_NAME, 'value', value.toString());
    this.logPropChanges( 'opacity.change', {
      itemId: item.getId(),
      prop: setting.key || INPUT_OPACITY_SETTINGS_NAME
    });
  }

  private logPropChanges(action: string, settings: {itemId: string, prop: string}) {
    const location = new URL(window.location.href);
    const httpService = appInjector.get(HttpServiceService);
    let params = new HttpParams()
      .set('action', action)
      .set('originalUrl', location.pathname);

    Object.keys(settings).forEach((key) => {
      params = params.set(key, settings[key]);
    });

    httpService
      .sendPostRequest(
        'site/client-action',
        params,
        new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe((res) => {});
  }

  getOpacitySettingsVal(){
    return (this.opacitySettings.value*100);
  }

  isHasRightMeasurement(setting: any): boolean {
    return this.isSettingHasMeasurement(setting);
  }

  isSettingEnabled(setting: any): boolean {
    const isColorEnabled = this.isColor(setting) ? this.isCanChangeColor : true;
    return setting.key.indexOf('__') != 0
      && setting.key != 'measurement'
      && !setting.value.hasOwnProperty('calculation')
      && isColorEnabled;
  }

  get isContainPreSet():boolean {
    return this.item.config.isContainPreset && isPresetEnabled;
  }

  isVertexOption(setting: any):boolean {
    return this.item.config.getObjectConfig().getToolType() == ObjectConfig.TYPE_POLYLINE && setting.value.hasOwnProperty('per_vertex');
  }

  hasObjectArray() {
    return ObjectArrayPlugin.isItemHasObjectArray(this.item);
  }
}
